export default {
  List: {
    Title: "Mất, hủy, thanh lý",
    CancelAssetList: "Danh sách tài sản đã hủy",
    CommonInfo: "Thông tin chung",
    LostAssetList: "Danh sách tài sản đã mất",
  },
  Detail: {
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetType: "Loại tài sản",
    Quantity: "Số lượng",
    Unit: "Đơn vị tính",
    LostAsset: "Tài sản mất",
    CancelAsset: "Tài sản hủy",
    LiquidatedAsset: "Tài sản thanh lý",
  },
  Cancel: {
    TitleForm: "Hủy tài sản",
    ErrorAssetCancel: "Không được phép hủy tài sản đã mất, hủy, thanh lý.",
    ValidateAssetStatus:
      "Chỉ được hủy tài sản có tình trạng chưa sử dụng, đang sử dụng, báo hỏng, đã hỏng, đề nghị thanh lý.",
    ValidateAssetStatusContinue:
      "Chỉ được phép hủy tài sản có tình trạng chưa sử dụng, đang sử dụng, báo hỏng, đã hỏng, đề nghị thanh lý. Bạn có chắc chắn muốn tiếp tục không?",
  },
  MultiCancel: {
    AddAsset: "Thêm dòng",
    QuickSelect: "Chọn nhanh",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetStatus: "Tình trạng",
    RemainQuantity: "Số lượng",
    Quantity: "Số lượng đánh dấu hỏng",
    Location: "Vị trí tài sản",
    Allocation: "Đối tượng sử dụng",
    Employee: "Nhân viên sử dụng",
    UsedOrganizationUnit: "Đơn vị sử dụng",
    Representative: "Người đại diện",
    QuantityOverload: "Số lượng đánh dấu hỏng hỏng phải thuộc khoảng từ 1 đến ##0##",

    OccurenceDateInValid:
      "Ngày đánh dấu hủy không được nhỏ hơn ngày phát sinh nghiệp vụ gần nhất (##0##)",
    AssetNotFound: "Phải chọn ít nhất 1 tài sản đánh dấu hủy.",
  },
  MultiRequestLiquidation: {
    RequestTitleDetail: "Thông tin chung",
    LiquidationDate: "Ngày đề nghị thanh lý",
    ListAsset: "Danh sách tài sản",
    AddAsset: "Thêm dòng",
    QuickSelect: "Chọn nhanh",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetStatus: "Tình trạng",
    RemainQuantity: "Số lượng",
    Quantity: "Số lượng ĐN thanh lý",
    QuantityTooltip: "Số lượng đề nghị thanh lý",
    Location: "Vị trí tài sản",
    Allocation: "Đối tượng sử dụng",
    Employee: "Nhân viên sử dụng",
    UsedOrganizationUnit: "Đơn vị sử dụng",
    Representative: "Người đại diện",
    Reason: "Lý do đề nghị thanh lý",
    ErrorNullRequestLiquidationDate: "Ngày đề nghị thanh lý không được phép bỏ trống",
    AssetWarning:
      "Chỉ được phép đề nghị thanh lý tài sản có tình trạng chưa sử dụng, đang sử dụng, đã hỏng, báo hỏng. Bạn có chắc chắn muốn tiếp tục không?",
    AssetInvalid:
      "Chỉ được phép đề nghị thanh lý tài sản có tình trạng chưa sử dụng, đang sử dụng, đã hỏng, báo hỏng.",
    QuantityOverload: "Số lượng đề nghị thanh lý phải thuộc khoảng từ 1 đến ##0##",
    OccurenceDateInValid:
      "Ngày đề nghị thanh lý không được nhỏ hơn ngày phát sinh nghiệp vụ gần nhất (##0##)",
    AssetExist: "Tài sản <##0##> đã tồn tại trong danh sách.",
    AssetNotFound: "Phải chọn ít nhất 1 tài sản đề nghị thanh lý.",
  },
  MultiLiquidation: {
    RequestTitleDetail: "Thông tin chung",
    LiquidationDate: "Ngày thanh lý",
    ListAsset: "Danh sách tài sản",
    DisposalAssetDecision: "Quyết định thanh lý",
    AddAsset: "Thêm dòng",
    QuickSelect: "Chọn nhanh",
    AssetCode: "Mã tài sản",
    AssetName: "Tên tài sản",
    AssetStatus: "Tình trạng",
    RemainQuantity: "Số lượng",
    Quantity: "Số lượng thanh lý",
    Location: "Vị trí tài sản",
    Allocation: "Đối tượng sử dụng",
    Employee: "Nhân viên sử dụng",
    UsedOrganizationUnit: "Đơn vị sử dụng",
    Representative: "Người đại diện",
    Reason: "Lý do thanh lý",
    ActualCost: "Giá trị thanh lý",
    ErrorNullRequestLiquidationDate: "Ngày thanh lý không được phép bỏ trống",
    AssetWarning:
      "Chỉ được phép thanh lý tài sản có tình trạng chưa sử dụng, đang sử dụng, đã hỏng, báo hỏng, đề nghị thanh lý. Bạn có chắc chắn muốn tiếp tục không?",
    AssetWarning1:
      "Chỉ được phép thanh lý tài sản có tình trạng đề nghị thanh lý. Bạn có chắc chắn muốn tiếp tục không?",
    AssetInvalid:
      "Chỉ được phép thanh lý tài sản có tình trạng chưa sử dụng, đang sử dụng, đã hỏng, báo hỏng, đề nghị thanh lý.",
    AssetInvalid1: "Chỉ được phép thanh lý tài sản có tình trạng đề nghị thanh lý.",
    QuantityOverload: "Số lượng thanh lý phải thuộc khoảng từ 1 đến ##0##",
    OccurenceDateInValid:
      "Ngày thanh lý không được nhỏ hơn ngày phát sinh nghiệp vụ gần nhất (##0##)",
    AssetExist: "Tài sản <##0##> đã tồn tại trong danh sách.",
    AssetExist: "Tài sản <##0##> đã tồn tại trong danh sách.",
    AssetNotFound: "Phải chọn ít nhất 1 tài sản thanh lý.",
  },
  MultiDisposal: {
    AssetNotFound: "Phải chọn ít nhất 1 tài sản đánh dấu mất.",
  },
};
